module.exports = __webpack_public_path__ + "img/qrcode.718d0d71.png";